"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightDrillDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var downloadFile_1 = require("../../../../../_staging/fileUtils/downloadFile");
var common_1 = require("../../../common");
var drill_1 = require("../../../../drill");
var localization_1 = require("../../../../localization");
var DrillDialog_1 = require("./DrillDialog");
var DrillDialogInsight_1 = require("./DrillDialogInsight");
var model_1 = require("../../../../../model");
var getTitleWithBreadcrumbs_1 = require("./getTitleWithBreadcrumbs");
var dashboardContexts_1 = require("../../../../dashboardContexts");
var presentationComponents_1 = require("../../../../presentationComponents");
var constants_1 = require("../../../../constants");
// Header z-index start at  6000 so we need force all overlays z-indexes start at 6000 to be above header
var overlayController = sdk_ui_kit_1.OverlayController.getInstance(constants_1.DASHBOARD_HEADER_OVERLAYS_Z_INDEX);
var overlayIgnoredClasses = [
    ".s-sort-direction-arrow",
    ".gd-export-dialog",
    ".options-menu-export-xlsx",
    ".options-menu-export-csv",
    "#" + downloadFile_1.DOWNLOADER_ID,
];
var DRILL_MODAL_EXECUTION_PSEUDO_REF = sdk_model_1.idRef("@@GDC_DRILL_MODAL");
exports.InsightDrillDialog = function (props) {
    var widget = props.widget, locale = props.locale, breadcrumbs = props.breadcrumbs, insight = props.insight, onClose = props.onClose, onBackButtonClick = props.onBackButtonClick, onDrillDown = props.onDrillDown;
    var isMobileDevice = sdk_ui_kit_1.useMediaQuery("mobileDevice");
    var _a = tslib_1.__read(react_1.useState(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var executionsHandler = model_1.useWidgetExecutionsHandler(DRILL_MODAL_EXECUTION_PSEUDO_REF);
    var _b = dashboardContexts_1.useDashboardComponentsContext({
        /**
         * There is a need to use Loading spinner instead of "Running three dots" loader while drill is loading.
         * If no custom loading component is provided, LoadingComponent defaults to Loading spinner.
         */
        LoadingComponent: presentationComponents_1.ThemedLoadingEqualizer,
    }), ErrorComponent = _b.ErrorComponent, LoadingComponent = _b.LoadingComponent;
    var handleLoadingChanged = react_1.useCallback(function (_a) {
        var isLoading = _a.isLoading;
        setIsLoading(isLoading);
        executionsHandler.onLoadingChanged({ isLoading: isLoading });
    }, []);
    var baseInsightTitle = sdk_model_1.insightTitle(insight);
    var _c = common_1.useInsightExport({
        title: getTitleWithBreadcrumbs_1.getTitleWithBreadcrumbs(baseInsightTitle, breadcrumbs),
        widgetRef: DRILL_MODAL_EXECUTION_PSEUDO_REF,
        insight: insight,
    }), exportCSVEnabled = _c.exportCSVEnabled, exportXLSXEnabled = _c.exportXLSXEnabled, onExportCSV = _c.onExportCSV, onExportXLSX = _c.onExportXLSX;
    var OverlayComponent = isMobileDevice ? sdk_ui_kit_1.FullScreenOverlay : sdk_ui_kit_1.Overlay;
    return (react_1.default.createElement(sdk_ui_kit_1.OverlayControllerProvider, { overlayController: overlayController },
        react_1.default.createElement(OverlayComponent, { className: "gd-drill-modal-overlay", isModal: true, closeOnEscape: true, closeOnOutsideClick: true, ignoreClicksOnByClass: overlayIgnoredClasses, onClose: onClose, positionType: "fixed" },
            react_1.default.createElement(localization_1.IntlWrapper, { locale: locale },
                react_1.default.createElement(DrillDialog_1.DrillDialog, { insightTitle: baseInsightTitle, isBackButtonVisible: breadcrumbs.length > 1, onBackButtonClick: onBackButtonClick, onCloseDialog: onClose, breadcrumbs: breadcrumbs, exportAvailable: exportXLSXEnabled || exportCSVEnabled, exportXLSXEnabled: exportXLSXEnabled, exportCSVEnabled: exportCSVEnabled, onExportXLSX: onExportXLSX, onExportCSV: onExportCSV, isLoading: isLoading },
                    react_1.default.createElement(drill_1.WithDrillSelect, { widgetRef: widget.ref, insight: props.insight, onDrillDownSuccess: onDrillDown }, function (_a) {
                        var onDrill = _a.onDrill;
                        return (react_1.default.createElement(DrillDialogInsight_1.DrillDialogInsight, tslib_1.__assign({}, props, { onDrill: onDrill, onLoadingChanged: handleLoadingChanged, onError: executionsHandler.onError, pushData: executionsHandler.onPushData, ErrorComponent: ErrorComponent, LoadingComponent: LoadingComponent })));
                    }))))));
};
//# sourceMappingURL=InsightDrillDialog.js.map